import { Col, Row, Spin, Tag, Typography } from "antd";
import { StyleSheet } from "../../../../StyleSheet";
import _ from "lodash";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAccounts, getSchedulersTransactions } from "../../../../methods/axiosMethods";
import { AccountResponse, DispersionData, ScheduledDispersionStatus, SchedulerResponse, Status } from "../../../../types/types";
import Table, { ColumnsType } from "antd/es/table";
import { InfoCircleOutlined, LoadingOutlined, RedoOutlined, WarningOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import DrawerRejected from "./DrawerRejected";
import Buttons from "../../../../components/Buttons";
import SelectInput from "../../../../components/SelectInput";
import ModalNotification, { AlertTypeNew } from "../../../../components/ModalNotification";
import { dispatch } from "../../../../store";
import { setAccount } from "../../../../store/slices/account";
import { formatAmount } from "../../../../functions/Functions";
import CustomPagination from "../../../../components/CustomPagination";
import Searcher from "../../components/Searcher";
const { Text } = Typography;

interface RejectedMainProps {
    selectHistoryType: ReactNode;
};

const RejectedMain = (props: RejectedMainProps) => {
    const { selectHistoryType } = props
    const [loading, setLoading] = useState(false);
    const accountsData = useSelector((state: any) => state.account.accountsInfo);
    const [accountsList, setAccountsList] = useState<Array<AccountResponse>>([]);
    const [scheduledList, setScheduledList] = useState<Array<SchedulerResponse>>([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<Array<SchedulerResponse>>([]);
    const [notificationType, setNotificationType] = useState<AlertTypeNew>("SUCCESS");
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [message, setMessage] = useState('');
    const [accDestTmp, setAccDestTmp] = useState("");
    const [totalPerPage, setTotalPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchWord, setSearchWord] = useState("");

    const columns: ColumnsType<SchedulerResponse> = [
        {
            title: "Acciones",
            align: "center",
            className: 'custom-header',
            dataIndex: "dispersionData",
            key: "dispersionData",
            render: (record: DispersionData) => (
                <div>
                    <Buttons
                        title="Más detalles"
                        type="default"
                        action={() => showDrawer(record)}
                        color="#3d3dff"
                        icon={<InfoCircleOutlined />}
                    />
                </div>
            ),
        },
        {
            title: "Estatus",
            className: 'custom-header',
            render: () => (
                <>
                    <WarningOutlined style={{ color: "red" }} /> &nbsp;&nbsp;
                    <Tag style={{ fontSize: 14 }} color={"red"}>
                        {"Rechazada"}
                    </Tag>
                </>
            ),
        },
        {
            title: "Fecha",
            align: "center",
            className: 'custom-header',
            dataIndex: "dispersionData",
            key: "dispersionData",
            render: (record: DispersionData) => dayjs(record.date).format("DD/MM/YYYY HH:mm")
        },
        // TODO: Revisar si se mostra o no la clave de ratreo en estos casos y ver de donde se obtendra.
        {
            title: "Monto",
            align: "center",
            className: 'custom-header',
            dataIndex: "dispersionData",
            key: "dispersionData",
            render: (record: DispersionData) => (
                <span style={{ color: "red" }}>
                    {record.balance !== 0 ?
                        formatAmount.format(record.balance + record.iva) : '$0.00'
                    }
                </span>
            ),
        },
        {
            title: "Causa Rechazo",
            className: 'custom-header',
            dataIndex: "errorDescription",
            key: "errorDescription",
        },
    ];

    const getAccountsList = useCallback(() => {
        setLoading(true);
        getAccounts()
            .then((response) => {
                if (response.data && response.data.data && response.data.status === Status.OK) {
                    setAccountsList(response.data.data);
                    dispatch(setAccount({
                        accountsInfo: response.data.data
                    }));
                }
            })
            .catch(() => {
                setNotificationType('ERROR');
                setMessage("Hubo un error al obtener las cuentas.");
                setShowNotification(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (_.isEmpty(accountsData)) {
            getAccountsList()
        } else {
            setAccountsList(accountsData);
        }
    }, [accountsData, getAccountsList]);

    const handleChangeAccount = (event: string) => {
        setAccDestTmp(event);
    };

    const showDrawer = (record: any) => {
        setOpenDrawer(true);
        setSelectedRecord(record);
    };

    const onCloseDrawer = () => {
        setOpenDrawer(false);
    };

    useEffect(() => {
        if (_.isEmpty(accDestTmp) && !_.isEmpty(accountsList)) {
            setAccDestTmp(accountsList[0].accountNumber);
        }
    }, [accountsList, accDestTmp]);

    useEffect(() => {
        setCurrentPage(1);
    }, [totalPerPage]);

    const fetchData = useCallback(
        (page?: number, pageChanged?: number, searchTerm?: string) => {

            setLoading(true);

            const currentPageTmp = page ? page - 1 : 0;
            const currentPageChangedTmp = pageChanged ?? 10;
            const searchTermTmp = searchTerm ? searchTerm : "";

            getSchedulersTransactions(accDestTmp, ScheduledDispersionStatus.REJECTED, currentPageTmp, currentPageChangedTmp, 'schedulerDate,desc', searchTermTmp)
                .then((response) => {
                    const { data } = response;
                    if (data?.status === Status.OK && data?.data?.content) {
                        const transactionsList = data.data.content;
                        setScheduledList(transactionsList);
                        setTotalRecords(data.data.totalElements);
                    } else {
                        setScheduledList([]);
                        setTotalRecords(0);
                    }
                })
                .catch(() => {
                    setScheduledList([]);
                    setTotalRecords(0);
                    setNotificationType('ERROR');
                    setMessage("Hubo un error al obtener la lista de  transferencias programadas.");
                    setShowNotification(true);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
        [accDestTmp]
    );

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        fetchData(page, totalPerPage, searchWord);
    };

    const handleTotalPerPage = (total: number) => {
        setTotalPerPage(total);
        fetchData(1, total, searchWord);
    };

    const handleSearch = async (text: string) => {
        if (_.isEmpty(text)) {
            setSearchWord("");
            fetchData(1, totalPerPage);
            setCurrentPage(1);
        } else {
            setSearchWord(text);
            fetchData(1, totalPerPage, text);
        }
    };

    useEffect(() => {
        if (accDestTmp) {
            fetchData();
        }
    }, [fetchData, accDestTmp]);

    return (
        <>
            <Row justify={"center"} gutter={[16, 16]}>
                <Col span={24}>
                    <Spin spinning={loading}>
                        <Row gutter={[16, 16]} style={styles.searcherMainContainer}>
                            <Col xs={24} sm={24} lg={6} xl={6}>
                                {selectHistoryType}
                            </Col>
                            <Col
                                xs={24} sm={24} lg={6} xl={6}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingLeft: 10, paddingRight: 10 }}
                            >
                                <Searcher
                                    placeholder="Buscar"
                                    onSearch={(value: string) => handleSearch(value)}
                                />
                            </Col>
                            <Col xs={24} sm={24} lg={6} xl={9}>
                                <SelectInput
                                    value={accDestTmp}
                                    label="Seleccione una cuenta"
                                    onChange={handleChangeAccount}
                                    options={
                                        accountsList.map(account => ({
                                            value: account.accountNumber,
                                            label: (account.alias + " | " + account.name + " | " + account.accountNumber)
                                        }))
                                    }
                                />
                            </Col>
                            <Col
                                xs={24} sm={24} lg={6} xl={3}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 10 }}
                            >
                                <Buttons
                                    title="Actualizar"
                                    action={() => fetchData(currentPage, totalPerPage, searchWord)}
                                    type="primary"
                                    color="#3d84ff"
                                    icon={<RedoOutlined />}
                                />
                            </Col>
                        </Row>
                    </Spin>
                </Col>
                <Col span={24}>
                    <Text style={styles.textStyle}>
                        Historial de Transferencias Programadas Rechazadas
                    </Text>
                </Col>
                <Col span={24}>
                    <Row style={styles.rowRoot}>
                        <div style={styles.primaryContainer}>
                            <Col style={{ marginTop: "20px" }}>
                                <Table
                                    dataSource={scheduledList}
                                    bordered
                                    columns={columns}
                                    size="small"
                                    scroll={{ y: 400, x: 700 }}
                                    locale={{ emptyText: "No hay datos disponibles" }}
                                    pagination={false}
                                    loading={{
                                        spinning: loading,
                                        indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />,
                                    }}
                                />
                            </Col>
                            <Col xs={24}>
                                <CustomPagination
                                    currentPage={currentPage}
                                    pageSize={totalPerPage}
                                    paginationTotal={totalRecords}
                                    onPageSizeChange={handleTotalPerPage}
                                    onPageChange={handlePageChange}
                                    showSizeChanger
                                />
                            </Col>
                        </div>
                    </Row>
                </Col>
            </Row>
            <DrawerRejected
                selectedRecord={selectedRecord}
                drawerVisible={openDrawer}
                onCloseDrawer={onCloseDrawer}
            />
            <ModalNotification
                title={"Programadas Rechazadas"}
                message={message}
                alertType={notificationType}
                show={showNotification}
                onClose={() => setShowNotification(false)}
            />
        </>
    );
}

const styles = StyleSheet.create({
    rowRoot: {
        height: "100%",
        width: "100%",
    },
    primaryContainer: {
        width: "100%",
        padding: "20px",
        backgroundColor: 'white',
        borderRadius: 10,
        boxShadow: "0px 0px 8px #00000029",
    },
    searcherMainContainer: {
        padding: 20,
        borderRadius: 10,
        backgroundColor: "#ffffff",
        boxShadow: "0px 0px 8px #00000029",
    },
    textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        color: "#000073"
    },
});

export default RejectedMain;
